// src/admin/AdminDashboardPublication.jsx
import { useEffect, useState } from 'react';
import api from '../api/axios';

// کامپوننت نمایش و انتخاب ستاره‌ها
function StarRating({ value, onRate }) {
  const numericValue = Number(value) || 0;

  return (
    <div>
      {[1, 2, 3, 4, 5].map(star => (
        <span
          key={star}
          style={{
            cursor: 'pointer',
            color: star <= numericValue ? 'gold' : 'lightgray',
            fontSize: '1.5rem'
          }}
          onClick={() => onRate(star)}
        >
          ★
        </span>
      ))}
    </div>
  );
}

export default function AdminDashboardPublication({ currentUserId }) {
  const [publications, setPublications] = useState([]);
  const [categories, setCategories] = useState([]);

  // فیلدهای فرم
  const [title, setTitle] = useState('');
  const [topic, setTopic] = useState('');
  const [pageCount, setPageCount] = useState('');
  const [fileFormat, setFileFormat] = useState('');
  const [fileSizeBytes, setFileSizeBytes] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [coverUrl, setCoverUrl] = useState('');
  const [category, setCategory] = useState('');
  const [publishDate, setPublishDate] = useState('');
  const [editingId, setEditingId] = useState(null);

  // گرفتن نشریات
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/api/publications');
        setPublications(data.items || data);
      } catch (err) {
        console.error('Error fetching publications', err);
      }
    })();
  }, []);

  // گرفتن دسته‌بندی‌ها
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/api/publication-categories');
        setCategories(data);
      } catch (err) {
        console.error('Error fetching publication categories', err);
      }
    })();
  }, []);

  async function addPublication(e) {
    e.preventDefault();
    try {
      const { data } = await api.post('/api/publications', {
        title,
        topic,
        pageCount,
        fileFormat,
        fileSizeBytes,
        fileUrl,
        coverUrl,
        categoryId: category,
        publishDate
      });
      setPublications(prev => [...prev, data]);
      resetForm();
    } catch (err) {
      console.error('Error adding publication', err);
    }
  }

  async function updatePublication(id) {
    try {
      const { data } = await api.put(`/api/publications/${id}`, {
        title,
        topic,
        pageCount,
        fileFormat,
        fileSizeBytes,
        fileUrl,
        coverUrl,
        categoryId: category,
        publishDate
      });
      setPublications(prev => prev.map(p => (p._id === id ? data : p)));
      resetForm();
    } catch (err) {
      console.error('Error updating publication', err);
    }
  }

  async function deletePublication(id) {
    try {
      await api.delete(`/api/publications/${id}`);
      setPublications(prev => prev.filter(p => p._id !== id));
    } catch (err) {
      console.error('Error deleting publication', err);
    }
  }

  function resetForm() {
    setTitle('');
    setTopic('');
    setPageCount('');
    setFileFormat('');
    setFileSizeBytes('');
    setFileUrl('');
    setCoverUrl('');
    setCategory('');
    setPublishDate('');
    setEditingId(null);
  }

  // آپلود فایل PDF به Cloudinary
  // 🔥 آپلود فایل PDF به Cloudinary
async function handleFileChange(e) {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('file', file);

  try {
    console.log('📤 Uploading publication file...', file);

    const { data } = await api.post('/api/upload/publication-file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    console.log('📥 Upload response from backend:', data);

    setFileUrl(data.url || '');
    setFileFormat((data.format || '').toLowerCase());
    setFileSizeBytes((data.bytes || file.size).toString());
  } catch (err) {
    console.error('❌ Error uploading publication file to Cloudinary', err);
  }
}
 
  // آپلود کاور به Cloudinary
  async function handleCoverChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      const { data } = await api.post('/api/upload/publication-cover', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setCoverUrl(data.url || '');
    } catch (err) {
      console.error('Error uploading publication cover to Cloudinary', err);
    }
  }

  // ثبت امتیاز کاربر
  async function ratePublication(id, value) {
    try {
      const { data } = await api.post(
        `/api/publications/${id}/rating`,
        { value },
        { withCredentials: true }
      );
      setPublications(prev => prev.map(p => (p._id === id ? data : p)));
    } catch (err) {
      console.error('Error rating publication', err);
    }
  }

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">Manage Publications</h1>

      {/* فرم افزودن/ویرایش */}
      <form
        onSubmit={
          editingId
            ? e => {
                e.preventDefault();
                updatePublication(editingId);
              }
            : addPublication
        }
        className="mb-4"
      >
        <input
          className="form-control mb-2"
          placeholder="Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <input
          className="form-control mb-2"
          placeholder="Topic"
          value={topic}
          onChange={e => setTopic(e.target.value)}
        />
        <input
          type="number"
          className="form-control mb-2"
          placeholder="Page Count"
          value={pageCount}
          onChange={e => setPageCount(e.target.value)}
        />

        <label className="form-label mt-2">Upload PDF</label>
        <input type="file" className="form-control mb-2" onChange={handleFileChange} />

        <label className="form-label mt-2">Publication Cover</label>
        <input type="file" className="form-control mb-2" onChange={handleCoverChange} />

        <select
          className="form-select mb-2"
          value={category}
          onChange={e => setCategory(e.target.value)}
        >
          <option value="">Select Publication Category</option>
          {categories.map(c => (
            <option key={c._id} value={c._id}>
              {c.name}
            </option>
          ))}
        </select>

        <input
          type="date"
          className="form-control mb-2"
          value={publishDate}
          onChange={e => setPublishDate(e.target.value)}
        />

        {editingId ? (
          <button className="btn btn-warning">Update Publication</button>
        ) : (
          <button className="btn btn-success">Add Publication</button>
        )}
        {editingId && (
          <button type="button" className="btn btn-secondary ms-2" onClick={resetForm}>
            Cancel
          </button>
        )}
      </form>

      {/* لیست نشریات */}
      <ul className="list-group">
        {publications.map(p => {
          let userRating = 0;

          if (Array.isArray(p.ratings)) {
            const foundRating = p.ratings.find(
              r => r.userId?.toString() === currentUserId?.toString()
            );
            if (foundRating) {
              userRating = Number(foundRating.value) || 0;
            }
          }

          return (
            <li
              key={p._id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div className="d-flex">
                {p.coverUrl && (
                  <img
                    src={p.coverUrl}
                    alt="cover"
                    style={{
                      width: '80px',
                      height: '110px',
                      objectFit: 'cover',
                      marginRight: '15px'
                    }}
                  />
                )}

                <div>
                  <strong>{p.title}</strong>
                  <br />
                  <small className="text-muted">
                    Topic: {p.topic} | Pages: {p.pageCount} | Format:{' '}
                    {(p.fileFormat || '').toUpperCase()} | Published:{' '}
                    {p.publishDate
                      ? new Date(p.publishDate).toLocaleDateString()
                      : 'N/A'}
                  </small>
                  <div className="mt-2">
                    <StarRating
                      value={userRating}
                      onRate={val => ratePublication(p._id, val)}
                    />
                  </div>
                </div>
              </div>

              <div>
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    setTitle(p.title || '');
                    setTopic(p.topic || '');
                    setPageCount(p.pageCount?.toString() || '');
                    setFileFormat(p.fileFormat || '');
                    setFileSizeBytes(p.fileSizeBytes?.toString() || '');
                    setFileUrl(p.fileUrl || '');
                    setCoverUrl(p.coverUrl || '');
                    setCategory(p.categoryId?._id || '');
                    setPublishDate(
                      p.publishDate ? p.publishDate.slice(0, 10) : ''
                    );
                    setEditingId(p._id);
                  }}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => deletePublication(p._id)}
                >
                  Delete
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
